import { Eye } from "@phosphor-icons/react";
import { ThemeToggle } from "@/components/observer/ThemeToggle";

// The left column used by sign-in, first-admin setup and setup links.
export const AuthShell = ({ eyebrow, title, intro, children, footer, testid }) => (
  <div className="noise grid-lines relative min-h-screen bg-[var(--o-bg)] text-[var(--o-fg)] flex" data-testid={testid}>
    <div className="relative z-10 flex flex-col justify-between gap-10 w-full max-w-xl px-6 sm:px-16 py-10 sm:py-14 border-r border-[var(--o-border)] bg-[var(--o-bg)]">
      <div className="flex items-center justify-between rise">
        <div className="flex items-center gap-3">
          <Eye size={22} weight="bold" />
          <span className="font-display text-xl font-extrabold tracking-tight">GoNav.Tech - Observer</span>
        </div>
        <ThemeToggle />
      </div>
      <div className="space-y-8 rise" style={{ animationDelay: "120ms" }}>
        <div className="space-y-4">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--o-muted2)]">{eyebrow}</p>
          <h1 className="font-display text-4xl sm:text-5xl font-black leading-[0.95] tracking-tight">{title}</h1>
          {intro && <p className="text-sm sm:text-base text-[var(--o-muted)] max-w-sm">{intro}</p>}
        </div>
        {children}
      </div>
      <p className="font-mono text-[11px] text-[var(--o-muted3)] rise" style={{ animationDelay: "240ms" }}>{footer}</p>
    </div>
  </div>
);

export const Field = ({ label, ...props }) => (
  <label className="block space-y-1.5">
    <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--o-muted2)]">{label}</span>
    <input {...props} className="w-full bg-transparent border border-[var(--o-border)] focus:border-[var(--o-fg)] px-4 py-3 text-sm outline-none transition-colors placeholder:text-[var(--o-muted3)]" />
  </label>
);
